import { type TranslationMessages } from 'react-admin'
import jaMessages from '@bicstone/ra-language-japanese'

export const ja: TranslationMessages = {
  ...jaMessages,
  resources: {
    users: {
      edit: {
        title: '対象の利用者/利用拠点の検索',
        fields: {
          name: '氏名',
          address: '住所',
          place: '物件名'
        },
        buttons: {
          search: '検索'
        }
      },
      show: {
        title: '解約予定日の入力',
        fields: {
          stop: '解約予定日',
          phone: '携帯電話番号',
          email: 'メールアドレス',
          family: {
            name: '緊急連絡先氏名',
            nameKana: '緊急連絡先氏名カナ(全角)',
            sms: '緊急連絡先SMS送信先電話番号',
            phone: '緊急連絡先電話番号',
            email: '緊急連絡先メールアドレス',
            postalCode: '緊急連絡先郵便番号'
          },
          schedules: '不在予定',
          criterion: {
            start: '判定開始時間',
            end: '判定終了時間',
            continuousLimit: '判定連続日数',
            criterionsOwn: '個別の判定条件を設定'
          },
          product: '通知先管理会社'
        },
        buttons: {
          confirm: '確認',
          submit: '設定',
          reserve: '設定予約',
          cancelReserve: '設定予約の確認・取消し',
          directDebit: '口座情報の変更',
          creditCard: 'カード情報の変更'
        },
        list: {
          title: '対象の利用者/利用拠点を選択してください'
        },
        record: {
          title: '対象の利用者/利用拠点'
        },
        notifications: {
          notFound: '該当する利用者/利用拠点が見つかりません。'
        },
        parsonal: {
          useageStatus: {
            title: 'ご利用状況'
          },
          record: {
            title: 'ご登録情報',
            edit: 'ご登録情報の変更'
          },
          schedules: {
            title: '外出予定の登録',
            edit: '外出予定の登録'
          },
          payment: {
            title: 'お支払い方法',
            edit: 'お支払情報の変更・更新をする場合は、下記よりお手続きを行ってください。'
          },
          contacts: {
            title: '解約・各種お問い合わせ',
            description:
              '解約手続きや各種お問い合わせは、以下を押下してください。',
            button: 'お問い合わせ'
          },
          buttons: {
            confirm: '確認',
            submit: '送信',
            cancel: 'キャンセル',
            close: '閉じる'
          }
        },
        reserve: {
          title: '設定予約',
          date: '日付',
          save: '設定'
        },
        cancelReserve: {
          title: '設定予約の確認・取消し',
          close: '閉じる',
          exec: '取消し'
        }
      },
      fields: {
        name: '氏名/拠点名',
        address: '住所',
        place: '物件名',
        placeNumber: '部屋番号',
        phone: '電話番号',
        email: 'メールアドレス',
        start: '利用開始日',
        stop: '解約予定日',
        end: '解約日',
        status: '利用状況',
        product: '担当管理会社',
        'families.0': {
          name: '緊急連絡先氏名',
          nameKana: '緊急連絡先氏名カナ',
          sms: '緊急連絡先SMS送信先電話番号',
          phone: '緊急連絡先電話番号',
          email: '緊急連絡先メールアドレス',
          postalCode: '緊急連絡先郵便番号'
        },
        contractor: {
          name: '電気契約者氏名',
          address: '電気契約者住所'
        }
      },
      solarFields: {
        name: '氏名/拠点名',
        address: '住所',
        phone: '電話番号',
        start: '利用開始日',
        stop: '解約予定日',
        end: '解約日',
        status: 'ご利用状況',
        product: 'ご担当管理会社',
        contractor: {
          name: '電気契約名義',
          address: '電気契約名義住所'
        },
        classification: '受給区分（受電／供給）',
        spin: '受電/供給地点特定番号'
      },
      parsonalFields: {
        name: '氏名',
        address: '住所',
        place: '物件名',
        placeNumber: '部屋番号',
        phone: '電話番号',
        email: 'メールアドレス',
        start: '利用開始日',
        stop: '解約予定日',
        end: '解約日',
        status: '利用状況',
        product: '担当管理会社',
        'families.0': {
          name: '緊急連絡先氏名',
          nameKana: '緊急連絡先氏名カナ',
          sms: '緊急連絡先SMS送信先電話番号',
          phone: '緊急連絡先電話番号',
          email: '緊急連絡先メールアドレス',
          postalCode: '緊急連絡先郵便番号'
        },
        contractor: {
          name: '電気契約者氏名',
          address: '電気契約者住所'
        }
      }
    },
    externalUsers: {
      edit: {
        title: '対象の利用者/利用拠点の検索',
        fields: {
          name: '氏名',
          address: '住所'
        },
        buttons: {
          search: '検索'
        }
      },
      show: {
        fields: {
          name: '氏名/拠点名',
          nameKana: '氏名/拠点名カナ',
          postalCode: '郵便番号',
          address: '住所',
          phone: '電話番号',
          sms: '携帯電話番号',
          contractor: {
            name: '電気契約者氏名',
            nameKana: '電気契約者氏名カナ',
            postalCode: '電気契約者郵便番号',
            address: '電気契約者住所',
            phone: '電気契約者電話番号'
          },
          spin: '受電/供給地点特定番号'
        },
        buttons: {
          confirm: '確認',
          submit: '設定',
          pdfUpload: '同意書PDFの更新',
          pdf: '同意書PDFの取得',
          retry: '同意申込の再実行'
        },
        list: {
          title: '対象の利用者/利用拠点を選択してください'
        },
        record: {
          title: '対象の利用者/利用拠点'
        },
        notifications: {
          notFound: '該当する利用者/利用拠点が見つかりません。'
        }
      },
      fields: {
        name: '氏名/拠点名',
        nameKana: '氏名/拠点名カナ',
        postalCode: '郵便番号',
        address: '住所',
        phone: '電話番号',
        sms: '携帯電話番号',
        contractor: {
          name: '電気契約者氏名',
          nameKana: '電気契約者氏名カナ',
          postalCode: '電気契約者郵便番号',
          address: '電気契約者住所',
          phone: '電気契約者電話番号'
        },
        spin: '受電/供給地点特定番号'
      }
    },
    dashboard: {
      title: 'テラシテRサービス管理ページ',
      menu: {
        edit: '利用者/利用拠点情報の\n変更',
        download: '利用者/利用拠点\n一覧の取得',
        upload: '利用者/利用拠点情報の\n変更の一括登録',
        editContact: '通知先メールアドレスの\n追加・変更',
        summary: '申込未受領者一括取得',
        editOrganizations: '通知先管理会社の変更',
        downloadOrganizations: '管理会社一覧の取得',
        uploadOrganizations: '管理会社情報の\n一括登録/変更',
        downloadAccounts: '管理ツール発行済み\nアカウント一覧の取得',
        uploadAccounts: '管理アカウントの\n登録/削除',
        contactList: '不備確認リスト一覧'
      },
      admin: {
        download: 'アカウント一覧の取得',
        upload: 'アカウントの登録/削除'
      },
      notification: {
        cannotUse: 'ご利用できません',
        submit: '登録しました',
        submitFail: '登録できません'
      }
    },
    admin: {
      announces: {
        title: '事業者別',
        commonTitle: '共通',
        label: 'お知らせ内容のファイル',
        fileSelect: '登録するファイルを選択 (エクセル)',
        download: '編集用ファイルのダウンロード',
        files: {
          label: 'ダウンロード対象のファイル',
          fileSelect: '登録するファイルを選択 (PDF)'
        },
        upload: '登録',
        uploadFail: 'アップロードに失敗しました',
        uploadComplete: 'アップロード完了',
        downloadFail: 'ファイルの取得に失敗しました',
        preview: 'プレビュー',
        close: '閉じる'
      }
    },
    download: {
      dialog: {
        content:
          '利用者/利用拠点一覧を取得するURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
        buttons: {
          cancel: 'キャンセル',
          confirm: 'ダウンロード'
        }
      }
    },
    upload: {
      dialog: {
        content:
          '取得した利用者/利用拠点一覧のファイルに変更内容を入力したファイルのアップロードを行ってください。\n\nなお、解約予定日、電話番号、緊急連絡先の情報以外の項目を変更されても反映されませんのでご注意ください。',
        buttons: {
          cancel: 'キャンセル',
          confirm: 'アップロード'
        }
      },
      notification: {
        uploading: 'アップロード中...',
        'cannot upload': 'アップロードできません。'
      }
    },
    partnerSelect: {
      dialog: {
        buttons: {
          prev: '前へ',
          next: '次へ',
          cancel: 'キャンセル',
          confirm: '設定',
          selectOrganization: '通知先/管理会社の選択'
        },
        title: '事業者の選択',
        selectOrganizationTitle: '通知先/管理会社の選択',
        filter: '検索'
      }
    },
    cognito: {
      download: {
        dialog: {
          content:
            'アカウント一覧を取得するURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        }
      },
      upload: {
        dialog: {
          content:
            '必ず取得したアカウント一覧のファイルを編集したファイルのアップロードを行ってください。\n\nなお、一覧から削除するとアカウントの削除が行われますのでご注意ください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'アップロード'
          }
        },
        notification: {
          uploading: 'アップロード中...',
          'cannot upload': 'アップロードできません。'
        }
      },
      execute: {
        confirm: 'アカウントの削除を実行するには、ボタンを押してください。',
        buttons: {
          execute: '実行'
        },
        dialog: {
          title: 'アカウントの削除の実行',
          content: 'アカウントの削除を実行します。',
          cancel: 'キャンセル',
          confirm: '実行'
        },
        notify: {
          complete: '実行しました',
          error: '実行でエラーが発生しました'
        }
      }
    },
    changeContact: {
      execute: {
        confirm: '管理会社変更を実行するには、ボタンを押してください。',
        buttons: {
          execute: '実行'
        },
        dialog: {
          title: '管理会社変更の実行',
          content: '管理会社変更を実行します。',
          cancel: 'キャンセル',
          confirm: '実行'
        },
        notify: {
          complete: '実行しました',
          error: '実行でエラーが発生しました'
        }
      }
    },
    editOrganizations: {
      download: {
        dialog: {
          content:
            '管理会社情報の一覧を取得するURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        }
      },
      upload: {
        dialog: {
          content:
            '取得した管理会社情報一覧のファイルに変更内容を入力したファイルのアップロードを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'アップロード'
          }
        },
        notification: {
          uploading: 'アップロード中...',
          'cannot upload': 'アップロードできません。'
        }
      },
      execute: {
        confirm:
          '管理会社情報の追加・変更を実行するには、ボタンを押してください。',
        buttons: {
          execute: '実行'
        },
        dialog: {
          title: '管理会社情報の追加・変更の実行',
          content: '管理会社情報の追加・変更を実行します。',
          cancel: 'キャンセル',
          confirm: '実行'
        },
        notify: {
          complete: '実行しました',
          error: '実行でエラーが発生しました'
        }
      }
    },
    editAccounts: {
      download: {
        dialog: {
          content:
            '管理アカウントの一覧を取得するURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        },
        notFound: 'アカウントが存在しません'
      },
      upload: {
        dialog: {
          content:
            '取得した管理アカウント情報一覧のファイルに変更内容を入力したファイルのアップロードを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'アップロード'
          }
        },
        notification: {
          uploading: 'アップロード中...',
          'cannot upload': 'アップロードできません。'
        }
      },
      execute: {
        confirm: '管理アカウントの削除を実行するには、ボタンを押してください。',
        buttons: {
          execute: '実行'
        },
        dialog: {
          title: '管理アカウントの削除の実行',
          content: '管理アカウントの削除を実行します。',
          cancel: 'キャンセル',
          confirm: '実行'
        },
        notify: {
          complete: '実行しました',
          error: '実行でエラーが発生しました'
        }
      }
    },
    contactListDownload: {
      download: {
        dialog: {
          content:
            '下記の「ダウンロード」ボタンを押下いただきますと、ダウンロード用のURLをメールにてお送りします。なお、URLの有効期限は1日間となっております。有効期限を過ぎた場合は、お手数ですが本ページより再度お手続きをお願い致します。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        }
      }
    },
    summary: {
      download: {
        dialog: {
          content:
            '見守りサービスの申込書が届いていない/電子申込がお済でない入居者様の一覧を取得することが可能です。以下「ダウンロード」 を押下すると、ダウンロード用のURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        }
      }
    },
    announce: {
      title: 'サービスからのお知らせ'
    },
    contactEdit: {
      title: '通知先メールアドレスの編集',
      buttons: {
        save: '登録'
      }
    },
    organizationsEdit: {
      title: '通知先管理会社の編集',
      buttons: {
        save: '登録'
      },
      fields: {
        contactOrganization: '管理会社名',
        contactEmail: 'メールアドレス',
        organizationFilter: '管理会社名で検索',
        emailFilter: 'メールアドレスで検索'
      },
      dialogs: {
        cancel: '閉じる',
        done: '設定'
      }
    },
    orderR: {
      name: 'テラシテR申込フォーム',
      title: 'お申し込みフォーム',
      fields: {
        name: '氏名',
        nameKana: '氏名(カナ)',
        postalCode: '郵便番号(ハイフンなし)',
        address: '住所',
        place: '物件名',
        placeNumber: '部屋番号',
        sms: 'SMS送信先電話番号(ハイフンなし)',
        phone: '音声連絡先電話番号(ハイフンなし)',
        customerNumber: '電気契約のお客様番号(13桁数字)',
        email: 'メールアドレス',
        familyName: '緊急連絡先氏名',
        familyNameKana: '緊急連絡先氏名カナ',
        familyPhone: '緊急連絡先電話番号(ハイフンなし)',
        familyPostalCode: '緊急連絡先郵便番号',
        familyEmail: '緊急連絡先メールアドレス',
        identification: '公的証明書番号',
        bankCode: '金融機関コード',
        branchCode: '支店コード',
        accountType: '預金区分',
        accountNumber: '口座番号',
        accountName: '口座名義カナ',
        accountNameKanji: '口座名義(漢字)',
        savings: '普通',
        current: '当座',
        entry: '入居予定日'
      },
      addressInput: '住所自動入力',
      submit: {
        l1: '登録'
      },
      userTitle: 'ご契約者',
      familyTitle: '緊急連絡先',
      bankAccount: {
        title: 'ご登録口座の変更',
        dialog: {
          content: '金融機関サイトへ移動します',
          ok: '確認'
        },
        submitButton: '登録'
      }
    }
  },
  scheduleInput: {
    clear: 'クリア',
    cancel: 'キャンセル',
    set: '設定'
  },
  ra: {
    ...jaMessages.ra,
    auth: {
      ...jaMessages.ra.auth,
      require_new_password: '新しいパスワードを設定してください',
      username: 'アカウント(メールアドレス)',
      password: 'パスワード',
      confirm_password: 'パスワード(確認用)',
      sign_in: 'ログイン',
      sign_in_error: 'ログインエラー',
      auth_check_error: 'メールアドレスまたはパスワードが違います',
      forgot_password: 'パスワードをお忘れ/ご変更の方はこちらから',
      exec_forgot_password: '新しいパスワードの設定',
      require_verification_code: 'メールに届いた確認コードを入力してください',
      verification_code: '確認コード',
      send_verification_code: '確認コードを送信'
    },
    validation: {
      ...jaMessages.ra.validation,
      do_not_match: 'パスワードが一致しません'
    }
  },
  required: '入力してください',
  'too small': '文字数が不足しています',
  'too large': '文字数が多すぎます',
  'Expected string, received null': '入力必須です',
  'cannot download summary': '取得できません',
  'invalid syntax': '不正な形式です',
  'uploading pdf': 'PDFファイルを送信中',
  'cannot upload pdf': 'PDFファイルを送信できません',
  'downloading pdf': 'PDFファイルを取得中',
  'cannot download pdf': 'PDFファイルを取得できません',
  retrying: '同意申込を再実行中',
  'failed retry': '同意申込の再実行を完了できません'
}
